"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var responsiveTypography_1 = require("./responsiveTypography");
exports.responsiveTypography = responsiveTypography_1.responsiveTypography;
//# sourceMappingURL=index.js.map